var SECTION_LABEL_REGEX = /^\s*\*{0,2}([A-Za-z][A-Za-z /-]{1,40}):\*{0,2}\s*/;

// Structured abstracts come back as one flat string. We split on lines and look for a
// "Label: text" convention so we can bold the label; anything that doesn't match a label
// just renders as a plain paragraph.
export var parseStructuredAbstract = function parseStructuredAbstract(text) {
  if (!text) {
    return [];
  }
  return text.split(/\n+/).map(function (line) {
    return line.trim();
  }).filter(Boolean).map(function (line) {
    var match = line.match(SECTION_LABEL_REGEX);
    if (!match) {
      return {
        heading: null,
        body: line
      };
    }
    return {
      heading: match[1].trim(),
      body: line.slice(match[0].length).trim()
    };
  });
};
export var hasSimpleSummary = function hasSimpleSummary(data) {
  return (data === null || data === void 0 ? void 0 : data.generatedSimpleSummary) !== undefined && (data === null || data === void 0 ? void 0 : data.generatedSimpleSummary) !== null;
};
export var hasGraphicalAbstract = function hasGraphicalAbstract(data) {
  return (data === null || data === void 0 ? void 0 : data.generatedGraphicalAbstractPrompt) !== undefined && (data === null || data === void 0 ? void 0 : data.generatedGraphicalAbstractPrompt) !== null;
};
export var buildKeywordsPlainText = function buildKeywordsPlainText(data) {
  return ((data === null || data === void 0 ? void 0 : data.generatedKeywords) || []).join(', ');
};
export var buildBundleParagraphs = function buildBundleParagraphs(data) {
  var paragraphs = [{
    text: 'Abstract',
    bold: true
  }, {
    text: (data === null || data === void 0 ? void 0 : data.generatedAbstract) || ''
  }, {
    text: 'Keywords',
    bold: true
  }, {
    text: buildKeywordsPlainText(data) || 'We were unable to generate Keywords. Please try again.'
  }];
  if (hasSimpleSummary(data)) {
    paragraphs.push({
      text: 'Simple Language Summary',
      bold: true
    });
    paragraphs.push({
      text: data.generatedSimpleSummary || 'We were unable to generate a Simple Language Summary. Please try again.'
    });
  }
  if (hasGraphicalAbstract(data)) {
    paragraphs.push({
      text: 'Graphical Abstract',
      bold: true
    });
    paragraphs.push({
      text: data.generatedGraphicalAbstractPrompt || 'We were unable to generate a Graphical Abstract. Please try again.'
    });
  }
  return paragraphs;
};
export var buildBundlePlainText = function buildBundlePlainText(data) {
  return buildBundleParagraphs(data).map(function (paragraph) {
    return paragraph.text;
  }).join('\n\n');
};

// Only strip characters that are actually illegal in filenames on Windows (the strictest of the
// common filesystems, so satisfying it satisfies macOS/Linux too). Everything else - including
// non-Latin scripts, spaces, and hyphens - should pass through untouched.
var ILLEGAL_FILENAME_CHARS = /["*/:<>?\\|]/g;
export var sanitizeFilename = function sanitizeFilename(name) {
  var withoutExtension = (name || 'abstract').replace(/\.[^/.]+$/, '');
  var cleaned = withoutExtension.replace(ILLEGAL_FILENAME_CHARS, '_').trim();
  return cleaned || 'abstract';
};